module.exports = __webpack_public_path__ + "img/bootcamp_bg_big.7116fd6b.png";